/**
 * Predefined (static) section and fields for the Rejoin Employee form.
 * Shown in the Rejoin Employee Form Builder as read-only rows (with active +
 * mandatory/optional toggles) and rendered with their bespoke widgets in the live
 * RejoinEmployee form. Admin-built custom field values are stored in customFields.
 *
 * `locked: true` marks fields the backend rejoin logic operationally requires - the
 * builder forces them Mandatory + visible and the backend always enforces them.
 * (employee_code is a hidden auto-filled field and is intentionally NOT listed here.)
 */

export const RE_PREDEFINED_SECTION_KEY = "predefined_rejoin_info";
export const RE_PREDEFINED_SECTION_NAME = "Employee Information";

export const RE_PREDEFINED_SECTION = {
  _id: "predefined_section",
  sectionName: RE_PREDEFINED_SECTION_NAME,
  sectionKey: RE_PREDEFINED_SECTION_KEY,
  isDefault: true,
  isPredefined: true,
  order: -1,
};

export const RE_PREDEFINED_FIELDS = [
  { fieldName: "initial", fieldLabel: "Initial", fieldType: "select", required: true, options: [{ key: "Mr.", value: "Mr." }, { key: "Ms.", value: "Ms." }, { key: "Mrs.", value: "Mrs." }], order: 0 },
  { fieldName: "first_name", fieldLabel: "First Name", fieldType: "text", required: true, order: 1, locked: true },
  { fieldName: "last_name", fieldLabel: "Last Name", fieldType: "text", required: true, order: 2, locked: true },
  { fieldName: "email", fieldLabel: "Email", fieldType: "email", required: true, order: 3, locked: true },
  { fieldName: "branch", fieldLabel: "Branch", fieldType: "select", required: true, order: 4, locked: true },
  { fieldName: "department_id", fieldLabel: "Department", fieldType: "select", required: true, order: 5, locked: true },
  { fieldName: "designation_id", fieldLabel: "Designation", fieldType: "select", required: true, order: 6, locked: true },
  { fieldName: "employee_type", fieldLabel: "Employee Type", fieldType: "select", required: true, order: 7, locked: true },
  { fieldName: "reporting_manager", fieldLabel: "Reporting Manager", fieldType: "select", required: true, order: 8, locked: true },
  { fieldName: "date_of_joining", fieldLabel: "Date of Joining", fieldType: "date", required: true, order: 9, locked: true },
  {
    fieldName: "isNewCode",
    fieldLabel: "Employee Code (New/Existing)",
    fieldType: "select",
    required: true,
    options: [{ key: "New", value: "true" }, { key: "Existing", value: "false" }],
    order: 10,
    locked: true,
  },
  { fieldName: "salary_grade", fieldLabel: "Salary Grade", fieldType: "select", required: true, order: 11 },
  {
    fieldName: "gender",
    fieldLabel: "Gender",
    fieldType: "select",
    required: true,
    options: [{ key: "Male", value: "Male" }, { key: "Female", value: "Female" }, { key: "Transgender", value: "Transgender" }],
    order: 12,
  },
  { fieldName: "fathername", fieldLabel: "Father Name", fieldType: "text", required: true, order: 13 },
  { fieldName: "mothername", fieldLabel: "Mother Name", fieldType: "text", required: true, order: 14 },
  {
    fieldName: "marital_status",
    fieldLabel: "Marital Status",
    fieldType: "select",
    required: false,
    options: [{ key: "Married", value: "Married" }, { key: "Un-Married", value: "Un-Married" }],
    order: 15,
  },
  { fieldName: "permail", fieldLabel: "Personal Mail ID", fieldType: "email", required: true, order: 16 },
  { fieldName: "pno", fieldLabel: "Personal Phone No", fieldType: "phone", required: true, order: 17 },
  { fieldName: "buddy", fieldLabel: "Buddy", fieldType: "select", required: false, order: 18 },
  { fieldName: "qualifications", fieldLabel: "Qualifications", fieldType: "text", required: true, order: 19 },
  { fieldName: "hobbies", fieldLabel: "Hobbies", fieldType: "text", required: true, order: 20 },
  { fieldName: "date_of_birth", fieldLabel: "Date Of Birth", fieldType: "date", required: true, order: 21 },
  { fieldName: "experience_grade", fieldLabel: "Experience Grade", fieldType: "select", required: false, order: 22 },
  { fieldName: "country", fieldLabel: "Country", fieldType: "select", required: true, order: 23 },
  { fieldName: "state", fieldLabel: "State", fieldType: "select", required: true, order: 24 },
  { fieldName: "district", fieldLabel: "District", fieldType: "text", required: true, order: 25 },
  { fieldName: "city", fieldLabel: "City/Village", fieldType: "select", required: true, order: 26 },
  { fieldName: "pin_code", fieldLabel: "Pin Code", fieldType: "text", required: true, order: 27 },
  { fieldName: "referred_by", fieldLabel: "Referred By", fieldType: "text", required: false, order: 28 },
  { fieldName: "experience", fieldLabel: "Experience", fieldType: "number", required: true, order: 29 },
  { fieldName: "address", fieldLabel: "Address", fieldType: "textarea", required: true, order: 30 },
];
